import { getDeviceType } from '~/utils/device'

/* Login Flow */
/** Fires `login_attempt` when the user submits login credentials. */
export const trackLoginAttempt = (content) => {
	const params = {
		method: content.method,
		email: content.email,
		device_type: getDeviceType(),
		timestamp: new Date().toISOString(),
	}
	LuckyWiseAnalytics.click('login_attempt', params)
}

/** Fires `login_success` after a successful authentication (any method). */
export const trackLoginSuccess = (content) => {
	const params = {
		method: content.method,
		email: content.email,
		device_type: getDeviceType(),
		user_id: content.user_id,
		timestamp: new Date().toISOString(),
	}
	LuckyWiseAnalytics.click('login_success', params)
}

/** Fires `login_failure` when authentication fails, including the failure reason. */
export const trackLoginFailure = (content) => {
	const params = {
		method: content.method,
		email: content.email,
		failure_reason: content.failure_reason,
		device_type: getDeviceType(),
		timestamp: new Date().toISOString(),
	}
	LuckyWiseAnalytics.click('login_failure', params)
}

/* Forgot Password Flow */
/** Fires `forgot_password_initiated` when the user opens the forgot-password form. */
export const trackForgotPasswordInitiated = (content) => {
	const params = {
		email_field_prefilled: content.email_field_prefilled,
		device_type: getDeviceType(),
		timestamp: new Date().toISOString(),
	}
	LuckyWiseAnalytics.click('forgot_password_initiated', params)
}

/** Fires `forgot_password_email_submitted` when the user submits the forgot-password form. */
export const trackForgotPasswordEmail = (content) => {
	const params = {
		email: content.email,
		device_type: getDeviceType(),
		timestamp: new Date().toISOString(),
	}
	LuckyWiseAnalytics.click('forgot_password_email_submitted', params)
}

/** Fires `forgot_password_email_sent` once the server confirms the reset email was dispatched. */
export const trackForgotPasswordEmailSent = (content) => {
	const params = {
		email: content.email,
		email_found: content.email_found,
		device_type: getDeviceType(),
		timestamp: new Date().toISOString(),
	}
	LuckyWiseAnalytics.click('forgot_password_email_sent', params)
}

// TODO: No implementado porque no encontre la casuistica
/** Fires `forgot_password_rate_limited` when the reset request is throttled by the server. */
export const trackForgotPasswordRateLimited = (content) => {
	const params = {
		email: content.email,
		device_type: getDeviceType(),
		timestamp: new Date().toISOString(),
	}

	LuckyWiseAnalytics.click('forgot_password_rate_limited', params)
}

/* Reset Password Flow */
/** Fires `reset_password_attempt` when the user submits a new password. */
export const trackResetPassword = (content) => {
	const params = {
		email: content.email,
		token_valid: content.token_valid,
		device_type: getDeviceType(),
		timestamp: new Date().toISOString(),
	}
	console.log({ params })

	LuckyWiseAnalytics.click('reset_password_attempt', params)
}

/** Fires `reset_password_success` after a successful password change. */
export const trackResetPasswordSuccess = (content) => {
	const params = {
		email: content.email,
		device_type: getDeviceType(),
		timestamp: new Date().toISOString(),
	}
	console.log({ params })

	LuckyWiseAnalytics.click('reset_password_success', params)
}

/** Fires `reset_password_failure` when a password-reset attempt fails. */
export const trackResetPasswordFailure = (content) => {
	const params = {
		email: content.email,
		failure_reason: content.failure_reason,
		device_type: getDeviceType(),
		timestamp: new Date().toISOString(),
	}
	console.log({ params })

	LuckyWiseAnalytics.click('reset_password_failure', params)
}
